import {
  useAccessToken,
  useSlug
} from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import {
  HandleErrorOptions,
  HandleSuccessOptions
} from 'reservations/booking/types';
import { useConfirmBookingMutation } from 'reservations/confirmation/queries/useConfirmBookingMutation';
import { useConfirmBookingMutationV2 } from 'reservations/confirmation/queries/useConfirmBookingMutationV2';

export const ConfirmReservationModal = () => {
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const { open, close } = useModal();
  const { handleNavigation } = useCustomRouter();
  const slug = useSlug();
  const accessToken = useAccessToken();
  const { bookingId } = useBookingDetails();
  const hasVisitId = useHasVisitId();

  const handleSuccess = ({ navUrl }: HandleSuccessOptions) => {
    handleHasLoaded();
    close();

    if (navUrl) {
      handleNavigation(navUrl);
    }
  };

  // istanbul ignore next
  const handleError = ({ navUrl, forceReload = false }: HandleErrorOptions) => {
    handleHasLoaded();
    close();

    if (navUrl || forceReload) {
      handleNavigation(navUrl, forceReload);
    }
  };

  const mutationV1 = useConfirmBookingMutation({
    slug,
    bookingId,
    apiKey: accessToken,
    handleSuccess,
    handleError
  });
  const mutationV2 = useConfirmBookingMutationV2();

  const onSubmit = () => {
    handleIsLoading('Confirming your reservation...');
    hasVisitId ? mutationV2.mutate() : mutationV1.mutate({});
  };

  return (
    <BaseDrawer
      header="Confirm Reservation"
      subheader="Please confirm your reservation to let the reservation know to expect you."
      primaryButton={{ label: 'Confirm Reservation', onClick: onSubmit }}
      secondaryButton={{
        label: "I Can't Make It",
        onClick: () => open(ModalType.CancelReservation)
      }}
      bookingDetailsDisplay="normal"
      requireAuth
    />
  );
};
